export const generateExampleType = (type) => {
	if (type === "string") {
		return `"String"`;
	} else if (type === "number" || type === "Integer") {
		return "0";
	} else if (type === "Float") {
		return "0.0";
	} else if (type === "any") {
		return "Any";
	} else if (type === "boolean") {
		return "false";
	}
};
